import React, { useState, ChangeEvent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "../../../utils/Hooks";
import { useLocation, useNavigate } from "react-router-dom";
import {Option} from "../../common/form/ElogSelect";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";

interface RangeSearchProps {
    url: string;
    userVisible: boolean;
}

const RangeSearch: React.FC<RangeSearchProps> = ({ url, userVisible }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();

    const [fromDate, setFromDate] = useState<string>('');
    const [fromDateObject, setFromDateObject] = useState<Date>(new Date());
    const [toDate, setToDate] = useState<string>('');
    const [toDateObject, setToDateObject] = useState<Date>(new Date());
    const [user, setUser] = useState<string>('0'); // Default to 'Kõik'

    const parseDate = function (dateString: string): Date {
        const [day, month, year] = dateString.split('.');
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        setFromDate(urlParams.get("from_date") || '');
        setToDate(urlParams.get("to_date") || '');
    }, []);

    useEffect(() => {

        if ( fromDate?.length > 0 ) {
            setFromDateObject(parseDate(fromDate));
        }

    },[fromDate]);

    useEffect(() => {

        if ( toDate?.length > 0 ) {
            setToDateObject(parseDate(toDate));
        }

    },[toDate])

    const handleSearch = () => {
        const searchParams = new URLSearchParams();
        searchParams.set("fromDate", fromDate);
        searchParams.set("toDate", toDate);
        if (userVisible) {
            searchParams.set("user", user);
        }
        const newUrl = `${url}?${searchParams.toString()}`;
        navigate(newUrl);
    };

    const usersState = useAppSelector(state => state.users);
    const userOptions: Option[] = [{ value: '0', label: 'Kõik' }, ...usersState.users
        .filter((user) => user.logistician === 1)
        .map((user) => ({
            value: user.id.toString(),
            label: `${user.firstname} ${user.lastname}`,
        }))];

    return (
        <form>
            <input type="hidden" name="page" value="emails" />
            <div className="filter clear" style={{ width: '99%' }}>
                <div className="content" style={{ width: '100%' }}>
                    <p>
                        <span style={{display: 'inline-flex'}}>
                        <label><strong>Periood:</strong></label>
                        <DatePicker
                            key={'from'}
                            value={fromDate}
                            selected={fromDateObject}
                            onChange={(date) => setFromDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        –
                        <DatePicker
                            key={'to'}
                            value={toDate}
                            selected={toDateObject}
                            onChange={(date) => setToDate(date ? dayjs(date).format('DD.MM.YYYY') : '')}
                            dateFormat={'dd.MM.yyyy'}
                            className={'date'}
                            locale="et"
                            showYearDropdown={true}
                            showMonthDropdown={true}
                        />
                        </span>
                        {userVisible && (
                            <>
                                &nbsp;&nbsp;&nbsp;
                                <label><strong>Kasutaja:</strong></label>
                                <select value={user} onChange={(e) => setUser(e.target.value)}>
                                    {userOptions.map(option => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </>
                        )}
                    </p>
                </div>
                <p className="action">
                    <button type="button" onClick={handleSearch}><span><strong>Vali</strong></span></button>
                </p>
            </div>
        </form>
    );
};

export default RangeSearch;